import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#fd7309',
    pc: {
        background: '/features/sola-20261109/pc_bg.jpg',
        overlay: 'rgba(253, 115, 9, 0.85)',
        eyebrow: '求人特集',
        titleLines: ['株式会社', 'そら'],
        contentsColor: '#fd7309',
    },
    hero: {
        image: '/features/sola-20261109/hero.jpg',
        alt: '株式会社そら 求人特集 鮨・焼鳥・韓国・イタリアンで 職人・店長候補などを募集！',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: '「' },
            { text: '世界一の', accent: true },
            { text: 'コトづくり', accent: true },
            { text: 'カンパニーになる」', breakBefore: true, hangEnd: true },
        ],
        paragraphs: [
            { text: '東京・千葉を中心に、多数のブランドを展開。' },
            {
                text: 'イタリアン・鮨・焼鳥・和食・カフェ・韓国・中華...etc',
                breakBefore: true,
            },
            {
                text: '1店舗1店舗コンセプトをしっかりと組み上げ、世の中にワクワクする楽しさを提供できる店舗を生み出しています。',
                breakBefore: true,
            },
        ],
    },
    thumbnail: {
        image: '/features/sola-20261109/top_sub.jpg',
        alt: '鮨店のカウンター席、手巻きの鮨、調理するスタッフの写真',
    },
    featuresTitle: ['そらで働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['完全週休2日、', '1日9時間勤務'],
            body: [
                '飲食業界の働く環境を改善していくことも重要だと考えており、完全週休2日、1日9時間勤務、それでいて未経験でも月給30万円スタート。飲食業界の労働環境を向上させるリーディングカンパニーとして、さらに進んでいきます。',
            ],
            image: '/features/sola-20261109/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['そらで働くメンバーが', '大切にしている人間力'],
            body: [
                '高い人間性を土台に、その土台の上にプロとしての専門技術や知識が身についていくことを大切にしています。料理技術が高いだけでは、そらでは活躍できません。人として、思考や行動を共に高めていける環境があります。',
            ],
            image: '/features/sola-20261109/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['「楽しい」と感じる体験を', '通して、新たな刺激を'],
            body: [
                '私たちそらグループは「楽しい」と感じる体験を通して人々の生活スタイルに新たな刺激を提供する事「Fun style＆Place」を実現します。',
            ],
            image: '/features/sola-20261109/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    jobs: {
        eyebrow: 'pickup',
        title: ['そら 求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'yoshikawa',
                categoryLabel: '鮨よしかわ',
                variant: 'carousel',
                description:
                    '恵比寿・麻布十番・銀座・新宿・中目黒にある、予約制の鮨店。寿司職人・調理見習い・店長などを募集しています。',
                jobs: [
                    {
                        offerId: '82539',
                        badgeLabel: '和食,寿司・鮨｜寿司職人',
                        title: '《高給＊完全週休2日＊残業少なめ＊インセンティブ》恵比寿の高級鮨で職人募集',
                        brandName: '鮨よしかわ 恵比寿店',
                        brandLogo: '/features/sola-20261109/logo_01.jpg',
                        salary: '35~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_01_01.jpg',
                        href: 'https://foods-labo.com/offers/82539',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-鮨よしかわ-1st',
                    },
                    {
                        offerId: '114926',
                        badgeLabel: '和食,寿司・鮨｜キッチンスタッフ',
                        title: '☆銀座の予約制のお鮨屋さん🍣☆未経験35万円～/1年以内に板場デビュー可',
                        brandName: '鮨よしかわ 勝 銀座',
                        brandLogo: '/features/sola-20261109/logo_01.jpg',
                        salary: '35~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '中央区',
                        image: '/features/sola-20261109/job_card_01_02.jpg',
                        href: 'https://foods-labo.com/offers/114926',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-鮨よしかわ-2nd',
                    },
                    {
                        offerId: '122922',
                        badgeLabel: '和食,寿司・鮨｜調理見習い・調理補助',
                        title: '【未経験から一流の鮨職人を目指す】圧倒的スピード感×ホワイトな労働環境',
                        brandName: '鮨よしかわ 海道 新宿店',
                        brandLogo: '/features/sola-20261109/logo_01.jpg',
                        salary: '35~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/sola-20261109/job_card_01_03.jpg',
                        href: 'https://foods-labo.com/offers/122922',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-鮨よしかわ-3rd',
                    },
                    {
                        offerId: '81294',
                        badgeLabel: '和食,寿司・鮨｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/麻布十番の予約制のお鮨屋さん',
                        brandName: '鮨よしかわ 麻布十番店',
                        brandLogo: '/features/sola-20261109/logo_01.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/sola-20261109/job_card_01_04.jpg',
                        href: 'https://foods-labo.com/offers/81294',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-鮨よしかわ-4th',
                    },
                    {
                        offerId: '81825',
                        badgeLabel: '和食,寿司・鮨｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/中目黒の予約制のお鮨屋さん',
                        brandName: '鮨よしかわ 鮨たつ也よしかわ',
                        brandLogo: '/features/sola-20261109/logo_01.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '目黒区',
                        image: '/features/sola-20261109/job_card_01_05.jpg',
                        href: 'https://foods-labo.com/offers/81825',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-鮨よしかわ-5th',
                    },
                ],
            },
            {
                id: 'sadajuro',
                categoryLabel: '佐田十郎',
                variant: 'carousel',
                description:
                    '六本木・恵比寿・中目黒・広尾・麻布十番にある、日本の季節を感じられる焼き鳥店。焼き鳥職人・店長などを募集しています。',
                jobs: [
                    {
                        offerId: '122974',
                        badgeLabel: '和食,焼き鳥｜焼き鳥職人',
                        title: '【焼き鳥職人募集】未経験でも月給32万〜＊ホワイトな環境＊自分らしく働く！',
                        brandName: '佐田十郎 恵比寿店',
                        brandLogo: '/features/sola-20261109/logo_02.jpg',
                        salary: '32~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_02_01.jpg',
                        href: 'https://foods-labo.com/offers/122974',
                        analyticsLabel: 'CT_Jobinformation_求人例-佐田十郎-1st',
                    },
                    {
                        offerId: '122976',
                        badgeLabel: '和食,焼き鳥｜焼き鳥職人',
                        title: '【経験者歓迎！未経験でも月給32万〜！】焼き鳥の名店「佐田十郎」｜広尾',
                        brandName: '佐田十郎 囲ム 広尾',
                        brandLogo: '/features/sola-20261109/logo_02.jpg',
                        salary: '32~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_02_02.jpg',
                        href: 'https://foods-labo.com/offers/122976',
                        analyticsLabel: 'CT_Jobinformation_求人例-佐田十郎-2nd',
                    },
                    {
                        offerId: '114930',
                        badgeLabel: '和食,焼き鳥｜キッチンスタッフ',
                        title: '☆裁量権豊富☆一流のサービス力/日本の季節を感じられる六本木の焼き鳥屋さん',
                        brandName: '佐田十郎 六本木店',
                        brandLogo: '/features/sola-20261109/logo_02.jpg',
                        salary: '30~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/sola-20261109/job_card_02_03.jpg',
                        href: 'https://foods-labo.com/offers/114930',
                        analyticsLabel: 'CT_Jobinformation_求人例-佐田十郎-3rd',
                    },
                    {
                        offerId: '81804',
                        badgeLabel: '和食,焼き鳥｜料理長・料理長候補',
                        title: '☆裁量権豊富☆店長38万円～/日本の季節を感じられる中目黒の焼き鳥屋さん',
                        brandName: '佐田十郎 中目黒',
                        brandLogo: '/features/sola-20261109/logo_02.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '目黒区',
                        image: '/features/sola-20261109/job_card_02_04.jpg',
                        href: 'https://foods-labo.com/offers/81804',
                        analyticsLabel: 'CT_Jobinformation_求人例-佐田十郎-4th',
                    },
                    {
                        offerId: '81805',
                        badgeLabel: '和食,焼き鳥｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/日本の季節を感じられる麻布十番の焼き鳥屋さん',
                        brandName: '佐田十郎 麻布十番店',
                        brandLogo: '/features/sola-20261109/logo_02.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/sola-20261109/job_card_02_05.jpg',
                        href: 'https://foods-labo.com/offers/81805',
                        analyticsLabel: 'CT_Jobinformation_求人例-佐田十郎-5th',
                    },
                ],
            },
            {
                id: 'uttori',
                categoryLabel: 'うっとり',
                variant: 'carousel',
                description:
                    '西葛西・成田・綱島・石垣島など、東京・千葉・神奈川・沖縄にある焼き鳥店。各店で店長・店長候補を募集しています。',
                jobs: [
                    {
                        offerId: '81816',
                        badgeLabel: '焼き鳥,居酒屋｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/西葛西の焼き鳥屋さん',
                        brandName: 'うっとり 西葛西店',
                        brandLogo: '/features/sola-20261109/logo_03.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '江戸川区',
                        image: '/features/sola-20261109/job_card_03_01.jpg',
                        href: 'https://foods-labo.com/offers/81816',
                        analyticsLabel: 'CT_Jobinformation_求人例-うっとり-1st',
                    },
                    {
                        offerId: '81826',
                        badgeLabel: '焼き鳥,居酒屋｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/成田にある焼き鳥屋さん',
                        brandName: 'うっとり 成田店',
                        brandLogo: '/features/sola-20261109/logo_03.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '成田市',
                        image: '/features/sola-20261109/job_card_03_02.jpg',
                        href: 'https://foods-labo.com/offers/81826',
                        analyticsLabel: 'CT_Jobinformation_求人例-うっとり-2nd',
                    },
                    {
                        offerId: '81827',
                        badgeLabel: '焼き鳥,居酒屋｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/緑ヶ丘の焼き鳥屋さん',
                        brandName: 'うっとり 緑が丘店',
                        brandLogo: '/features/sola-20261109/logo_03.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '八千代市',
                        image: '/features/sola-20261109/job_card_03_03.jpg',
                        href: 'https://foods-labo.com/offers/81827',
                        analyticsLabel: 'CT_Jobinformation_求人例-うっとり-3rd',
                    },
                    {
                        offerId: '81831',
                        badgeLabel: '焼き鳥,居酒屋｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/綱島にある焼き鳥屋さん',
                        brandName: 'うっとり 綱島店',
                        brandLogo: '/features/sola-20261109/logo_03.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横浜市港北区',
                        image: '/features/sola-20261109/job_card_03_04.jpg',
                        href: 'https://foods-labo.com/offers/81831',
                        analyticsLabel: 'CT_Jobinformation_求人例-うっとり-4th',
                    },
                    {
                        offerId: '81907',
                        badgeLabel: '焼き鳥,居酒屋｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/石垣島にある焼き鳥屋さん',
                        brandName: 'うっとり 石垣うっとり 石垣島ヴィレッジ店',
                        brandLogo: '/features/sola-20261109/logo_03.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '沖縄県',
                        city: '石垣市',
                        image: '/features/sola-20261109/job_card_03_05.jpg',
                        href: 'https://foods-labo.com/offers/81907',
                        analyticsLabel: 'CT_Jobinformation_求人例-うっとり-5th',
                    },
                ],
            },
            {
                id: 'sonon',
                categoryLabel: 'SONON',
                variant: 'carousel',
                description:
                    '恵比寿にある、本場の明洞餃子や自然派ワインを楽しめる韓国料理店。ホールスタッフ・店長などを募集しています。',
                jobs: [
                    {
                        offerId: '123064',
                        badgeLabel:
                            'アジア料理・エスニック,専門店（各国料理）｜レストランサービス・ホールスタッフ',
                        title: '《お洒落な韓国ビストロ》高水準の給与＊週休2日9時間勤務＊ワイン学べます',
                        brandName: 'SONON',
                        brandLogo: '/features/sola-20261109/logo_04.jpg',
                        salary: '32~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_04_01.jpg',
                        href: 'https://foods-labo.com/offers/123064',
                        analyticsLabel: 'CT_Jobinformation_求人例-SONON-1st',
                    },
                    {
                        offerId: '67945',
                        badgeLabel:
                            'アジア料理・エスニック,専門店（各国料理）｜料理長・料理長候補',
                        title: '☆裁量権豊富☆料理長3８万円～/恵比寿のお洒落な韓国ビストロ♪',
                        brandName: 'SONON',
                        brandLogo: '/features/sola-20261109/logo_04.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_04_02.jpg',
                        href: 'https://foods-labo.com/offers/67945',
                        analyticsLabel: 'CT_Jobinformation_求人例-SONON-2nd',
                    },
                    {
                        offerId: '67692',
                        badgeLabel:
                            'アジア料理・エスニック,専門店（各国料理）｜キッチンスタッフ',
                        title: '☆週休2日9時間勤務☆未経験30万円～/恵比寿のお洒落な韓国ビストロ♪',
                        brandName: 'SONON',
                        brandLogo: '/features/sola-20261109/logo_04.jpg',
                        salary: '30~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_04_03.jpg',
                        href: 'https://foods-labo.com/offers/67692',
                        analyticsLabel: 'CT_Jobinformation_求人例-SONON-3rd',
                    },
                    {
                        offerId: '67037',
                        badgeLabel:
                            'アジア料理・エスニック,専門店（各国料理）｜店長・店長候補',
                        title: '☆週休2日9時間勤務☆店長候補3８万円～/恵比寿のお洒落な韓国ビストロ♪',
                        brandName: 'SONON',
                        brandLogo: '/features/sola-20261109/logo_04.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_04_04.jpg',
                        href: 'https://foods-labo.com/offers/67037',
                        analyticsLabel: 'CT_Jobinformation_求人例-SONON-4th',
                    },
                ],
            },
            {
                id: 'azzurro',
                categoryLabel: 'Azzurro520',
                variant: 'carousel',
                description:
                    '千葉の柏・成田・海浜幕張と、東京の代々木にある、スパニッシュイタリアンの店。各店で店長・店長候補を募集しています。',
                jobs: [
                    {
                        offerId: '81814',
                        badgeLabel:
                            'イタリアン,創作・ダイニングバー｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/柏のスパニッシュイタリアン',
                        brandName: 'Azzurro520 Azzurro520柏店',
                        brandLogo: '/features/sola-20261109/logo_05.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '柏市',
                        image: '/features/sola-20261109/job_card_05_01.jpg',
                        href: 'https://foods-labo.com/offers/81814',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-Azzurro520-1st',
                    },
                    {
                        offerId: '81813',
                        badgeLabel:
                            'イタリアン,創作・ダイニングバー｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/成田のスパニッシュイタリアン',
                        brandName:
                            'Azzurro520 炭火イタリアン Azzurro520 成田店',
                        brandLogo: '/features/sola-20261109/logo_05.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '成田市',
                        image: '/features/sola-20261109/job_card_05_02.jpg',
                        href: 'https://foods-labo.com/offers/81813',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-Azzurro520-2nd',
                    },
                    {
                        offerId: '81815',
                        badgeLabel:
                            'イタリアン,創作・ダイニングバー｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/海浜幕張のスパニッシュイタリアン',
                        brandName: 'Azzurro520 海浜幕張店',
                        brandLogo: '/features/sola-20261109/logo_05.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '千葉市美浜区',
                        image: '/features/sola-20261109/job_card_05_03.jpg',
                        href: 'https://foods-labo.com/offers/81815',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-Azzurro520-3rd',
                    },
                    {
                        offerId: '81812',
                        badgeLabel:
                            'イタリアン,創作・ダイニングバー｜店長・店長候補',
                        title: '☆裁量権豊富☆店長38万円～/代々木のスパニッシュイタリアン',
                        brandName: 'Azzurro520 代々木店',
                        brandLogo: '/features/sola-20261109/logo_05.jpg',
                        salary: '38~60',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/sola-20261109/job_card_05_04.jpg',
                        href: 'https://foods-labo.com/offers/81812',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-Azzurro520-4th',
                    },
                ],
            },
        ],
    },
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
}
